import { inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export const ThemeStore = signalStore(
  { providedIn: 'root' },
  withState({ usingDarkTheme: false }),
  withMethods((store, meta = inject(Meta)) => ({
    setMetaThemeColor(isDarkMode: boolean) {
      // Remove existing meta tags
      meta.removeTag('name="theme-color"');
      meta.removeTag('name="apple-mobile-web-app-status-bar-style"');
      meta.removeTag('name="msapplication-navbutton-color"');
      meta.removeTag('name="mobile-web-app-status-bar-style"');

      if (isDarkMode) {
        meta.addTags([
          // Standard theme color for all browsers
          { name: 'theme-color', content: '#121212' },
          // iOS Safari
          { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
          // Windows Phone
          { name: 'msapplication-navbutton-color', content: '#121212' },
          // Android Chrome
          { name: 'mobile-web-app-status-bar-style', content: 'black-translucent' },
        ]);
      } else {
        meta.addTags([
          // Standard theme color for all browsers
          { name: 'theme-color', content: '#f6f8fa' },
          // iOS Safari
          { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
          // Windows Phone
          { name: 'msapplication-navbutton-color', content: '#f6f8fa' },
          // Android Chrome
          { name: 'mobile-web-app-status-bar-style', content: 'default' },
        ]);
      }
    },

    async toggleTheme() {
      const isDarkMode = !store.usingDarkTheme();
      document.body.classList.toggle('dark', isDarkMode);
      this.setMetaThemeColor(isDarkMode);

      patchState(store, { usingDarkTheme: isDarkMode });
      localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    },
    initTheme() {
      const storedTheme = localStorage.getItem('theme');
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (storedTheme) {
        document.body.classList.toggle('dark', storedTheme === 'dark');
        patchState(store, { usingDarkTheme: storedTheme === 'dark' });
      } else if (prefersDark) {
        document.body.classList.toggle('dark', true);
        patchState(store, { usingDarkTheme: true });
      }
      this.setMetaThemeColor(store.usingDarkTheme());
    },
  })),
);
